import { RouteRecordRaw } from 'vue-router';
import { authGuard } from '../guards/authGuard.js';
import AdminLayout from '@/shared/layouts/AdminLayout.vue';

export const inventoryRoutes: RouteRecordRaw = {
  path: '/inventory',
  component: AdminLayout,
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    requiredRoles: ['editor']
  },
  children: [
    {
      path: '',
      name: 'inventory',
      component: () => import('@/features/inventory/pages/InventoryPage.vue'),
      meta: {
        requiresAuth: true,
        requiredRoles: ['editor'],
        title: 'Inventory Management',
        subtitle: 'Manage parts inventory across all locations',
        description: 'Comprehensive inventory management system for tracking parts, stock levels, and supplier information.'
      }
    }
  ]
}; 